import Segment from '../shared/segment';

function StudentQuestionsHeader() {
  return (
    <Segment noMargin bg color='red' textAlign='center' className='flex flex-col gap-4'>
      <h1 className='text-xl font-medium'>غلط‌‌نامه</h1>
    </Segment>
  );
}

export default StudentQuestionsHeader;
